import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, ButtonArea} from 'react-weui';
import Config from '../../config';

class ChannelManagerBottom extends Component {
    constructor() {
        super();
        this.handleEditChannel = this.handleEditChannel.bind(this);
        this.handleAddChannel = this.handleAddChannel.bind(this);
        this.handleDelChannel = this.handleDelChannel.bind(this);
    }

    handleDelChannel() {
        this.props.dispatch({type: 'CHANNEL_SHOW_DEL_CHANNEL_DIALOG'});
    }

    handleEditChannel() {
        const {channelId} = this.props;
        window.location = Config.MAIN_URL + `/liveroom/edit_channel?channel_id=${channelId}`;
    }


    handleAddChannel() {
        const {channelId, liveroomId} = this.props;
        location.assign(`/liveroom/${liveroomId}/channel/create`)
        // window.location = Config.MAIN_URL + `/lecture/add?channel_id=${channelId}&liveroom_id=${liveroomId}`;
    }

    render() {
        const {isRelay} = this.props;
        return (
            <div style={{display: 'none'}}>
                {!isRelay ?
                    <ButtonArea className="channel-manager-bottom weui-padding bordertop-line" direction="horizontal">
                        <Button className="default-hover" type="primary" plain
                                onClick={this.handleEditChannel}>编辑专栏</Button>
                        <Button className="default-hover" onClick={this.handleAddChannel}>添加新课程</Button>
                    </ButtonArea>
                    :
                    <ButtonArea className="channel-manager-bottom weui-padding bordertop-line" direction="horizontal">
                        <Button className="default-hover" type="default"
                                onClick={this.handleDelChannel}>删除专栏</Button>
                    </ButtonArea>
                }
            </div>
        )
    }
}

export default connect((state) => ({
    channelId: state.channel.channel.id,
    liveroomId: state.channel.liveroom.id,
    isRelay: state.channel.channel.is_relay,
}))(ChannelManagerBottom)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelManagerBottom.js